import type { TFunction } from 'i18next';

/** Saved format names compare trimmed and case-blind (tmm-api's `PROFILE_NAME_TAKEN` rule). */
export function sameName(a: string, b: string): boolean {
  return a.trim().toLocaleLowerCase() === b.trim().toLocaleLowerCase();
}

/** The account's served institution, or its name when the institution is blank. */
export function formatInstitution(
  institution: string | null | undefined,
  accountName: string,
): string {
  const served = institution?.trim() ?? '';
  return served.length > 0 ? served : accountName;
}

/**
 * The uploaded file's type in capitals: CSV from a comma delimiter, TSV from a tab, otherwise the
 * extension (TXT when the name has none).
 */
export function formatFileType(delimiter: string, filename: string): string {
  if (delimiter === ',') return 'CSV';
  if (delimiter === '\t') return 'TSV';
  const base = filename.split(/[/\\]/).pop() ?? '';
  const dot = base.lastIndexOf('.');
  const ext = dot > 0 ? base.slice(dot + 1) : '';
  return ext.length > 0 ? ext.toUpperCase() : 'TXT';
}

/** The first free "{name} ({n})" from 2 up, given the names already used. */
export function uniqueName(t: TFunction, name: string, taken: readonly string[]): string {
  for (let n = 2; ; n += 1) {
    const candidate = t('imports.fit.nameCopy', { name, n });
    if (!taken.some((used) => sameName(used, candidate))) return candidate;
  }
}
